"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _BasicColumn = _interopRequireDefault(require("./BasicColumn"));

var _localization = require("../../../../toolkit/localization");

//
//  src/data/table/BooleanColumn.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 3/30/2020
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Relative Imports */
var _default = (0, _mobxReact.observer)(function (props) {
  var _useLocalization = (0, _localization.useLocalization)(),
      i18n = _useLocalization.i18n;

  return /*#__PURE__*/_react["default"].createElement(_BasicColumn["default"], props, function (cell) {
    var value = cell.value;

    if (value == null) {
      return i18n("N/A");
    }

    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: value ? "greenCheckmarkSolid" : "redXSolid",
      alt: value ? i18n("True") : i18n("False"),
      style: {
        width: 20,
        height: 20
      }
    });
  });
});

exports["default"] = _default;